import React, { useState } from "react";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

export default function StaffNoteWithdrawalDialog({
  note,
  onWithdraw,
  onClose,
}) {
  const [busy, setBusy] = useState(false),
    [error, setError] = useState("");
  const confirm = async () => {
    setBusy(true);
    setError("");
    try {
      await onWithdraw(note);
      onClose();
    } catch (failure) {
      setError(
        failure.message || "The unsigned original could not be deleted.",
      );
    } finally {
      setBusy(false);
    }
  };
  return (
    <Dialog open fullWidth maxWidth="sm" onClose={busy ? undefined : onClose}>
      <DialogTitle>Delete unsigned original?</DialogTitle>
      <DialogContent>
        {error ? <Alert severity="error">{error}</Alert> : null}
        <Typography>
          Withdraw this original and its linked Timeline entries? The original
          and version history stay available. Dependent facts will need review.
        </Typography>
        <Typography
          sx={{
            mt: 2,
            whiteSpace: "pre-wrap",
            maxHeight: 240,
            overflow: "auto",
          }}
        >
          {note.version.text}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button disabled={busy} onClick={onClose}>
          Cancel
        </Button>
        <Button color="error" disabled={busy} onClick={confirm}>
          {busy ? "Deleting…" : "Delete unsigned original"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
